import { Application } from '@hotwired/stimulus'

// Extend Window interface to include Stimulus property
declare global {
  interface Window {
    Stimulus: Application
  }
}

const application = Application.start()

// Configure Stimulus development experience
application.debug = true
window.Stimulus = application

export { application }
